document.addEventListener("DOMContentLoaded", function () {

  const cartDrawer = document.getElementById("CartDrawer");
  const cartItemsContainer = document.getElementById("CartDrawerItems");

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.add("active");
    }
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.remove("active");
    }
  }

  // Close button
  document.addEventListener("click", function(e) {
    if (e.target.closest(".cart-close") || e.target.closest(".cart-drawer-overlay")) {
      closeCartDrawer();
    }
  });

  // FORM Add to Cart (Product page / Collection)
  document.body.addEventListener("submit", function(e) {

  if (e.target.matches('form[action="/cart/add"]')) {
    e.preventDefault();

    let formData = new FormData(e.target);

    fetch("/cart/add.js", {
      method: "POST",
      body: formData
    })
    .then(res => res.json())
    .then(() => {
      document.getElementById("CartDrawer").classList.add("active");
      fetchCartItems();
    });

  }

});

  // Custom Button Add to Cart
  document.addEventListener("click", function(e){

    let btn = e.target.closest(".custom-add-btn");

    if (btn) {

      let variantId = btn.dataset.variantId;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(res => res.json())
      .then(() => {
        openCartDrawer();
        fetchCartItems();
      })
      .catch(err => console.error("Cart error:", err));

    }

  });

  // Refresh drawer content
 function fetchCartItems() {
  fetch('/?section_id=cart-drawer')
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.querySelector('#CartDrawerItems');

      if (newContent) {
        document.getElementById('CartDrawerItems').innerHTML = newContent.innerHTML;
      }
    });
}

});